import React from 'react';
import { Target, Lightbulb, Users, Shield, Award, Heart, Leaf, FileCheck, CheckCircle2 } from 'lucide-react';
import { ValueCard } from '../components/ValueCard';
import { SEOSchema } from '../components/SEOSchema';
import { useLanguage } from '../contexts/LanguageContext';
export function AboutPage() {
  const {
    t
  } = useLanguage();
  return <div className="pt-20 min-h-screen bg-white" data-id="element-280">
      <SEOSchema type="about" title={t('Tentang Kami | PT Graha Riau Gemilang Developer Properti', 'About Us | PT Graha Riau Gemilang Real Estate Developer')} description={t('Mengenal PT Graha Riau Gemilang, pengembang properti berpengalaman lebih dari 20 tahun dengan puluhan proyek hunian dan komersial.', 'Learn about PT Graha Riau Gemilang, a well-established real estate developer in Riau with over 20 years of experience and proven projects.')} breadcrumbs={[{
      name: t('Beranda', 'Home'),
      url: 'https://grahariaugemilang.com/'
    }, {
      name: t('Tentang Kami', 'About Us'),
      url: 'https://grahariaugemilang.com/tentang-kami'
    }]} data-id="element-281" />

      {/* Header */}
      <div className="bg-gray-50 py-16" data-id="element-282">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-283">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-284">
            {t('Tentang Kami', 'About Us')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-285">
            {t('Mengenal lebih dekat PT Graha Riau Gemilang, pengembang properti terpercaya di Riau.', 'Learn about PT Graha Riau Gemilang, a well-established real estate developer in Riau.')}
          </p>
        </div>
      </div>

      {/* Company Profile */}
      <section className="py-20" data-id="element-286">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-288">
            <div className="lg:w-1/2" data-id="element-289">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-290">
                {t('Profil Perusahaan', 'Company Profile')}
              </h2>
              <div className="prose prose-lg text-gray-600" data-id="element-291">
                <p className="mb-4" data-id="element-292">
                  {t('PT Graha Riau Gemilang merupakan perusahaan pengembang properti yang berdiri sejak 7 April 2005. Dengan pengalaman lebih dari 20 tahun, kami telah menyelesaikan puluhan proyek hunian dan komersial yang menjadi pilihan ribuan keluarga Indonesia.', 'Founded on April 7, 2005, PT Graha Riau Gemilang is a well-established real estate development company with over 20 years of experience. We have successfully delivered dozens of residential and commercial projects, earning the trust of thousands of homeowners and business partners.')}
                </p>
                <p data-id="element-293">
                  {t('Komitmen kami adalah menghadirkan properti dengan standar kualitas tinggi, inovatif, dan memberikan nilai jangka panjang bagi penghuni maupun investor.', 'Our commitment lies in delivering properties that meet high quality standards, incorporate innovation, and provide long-term value.')}
                </p>
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-294">
              <div className="rounded-2xl overflow-hidden shadow-premium-lg" data-id="element-295">
                <img src="https://cdn.magicpatterns.com/uploads/9Xm28KaLFmnTEqcYBohmkM/PT.-Graha-riau-gemilang_MSDL.jpg" alt="Kantor PT Graha Riau Gemilang" className="w-full h-auto object-cover" data-id="element-296" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Legal Documentation Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white" data-id="element-297">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298">
          <div className="text-center mb-12" data-id="element-299">
            <div className="inline-block p-3 bg-green-50 rounded-full mb-4" data-id="element-300">
              <FileCheck className="w-8 h-8 text-green-600" data-id="element-301" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-302">
              {t('Legalitas Perusahaan', 'Legal Documentation')}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-303">
              {t('Dokumen resmi dan legalitas lengkap untuk keamanan dan kepercayaan Anda.', 'Complete official documentation and legal compliance for your security and trust.')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-304">
            {/* Legal Documents Card */}
            <div className="bg-white rounded-2xl border border-gray-200 shadow-premium p-8" data-id="element-305">
              <div className="flex items-center mb-6" data-id="element-306">
                <div className="bg-green-100 p-3 rounded-full text-green-600 mr-4" data-id="element-307">
                  <FileCheck className="w-8 h-8" data-id="element-308" />
                </div>
                <div data-id="element-309">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-310">
                    {t('Dokumen Resmi', 'Official Documents')}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-311">
                    PT Graha Riau Gemilang
                  </p>
                </div>
              </div>

              <ul className="space-y-4" data-id="element-312">
                <li className="flex items-start" data-id="element-313">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-314" />
                  <div data-id="element-315">
                    <span className="block font-medium text-gray-900" data-id="element-316">
                      {t('Akta Pendirian No. 97', 'Deed of Establishment No. 97')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-317">
                      {t('Notaris H. Asman Yunus, S.H.', 'Notary H. Asman Yunus, S.H.')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-318">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-319" />
                  <div data-id="element-320">
                    <span className="block font-medium text-gray-900" data-id="element-321">
                      {t('SK Menteri Kehakiman', 'Ministry of Justice Decree')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-322">
                      No. C-264 HT.03.01
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-323">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-324" />
                  <div data-id="element-325">
                    <span className="block font-medium text-gray-900" data-id="element-326">
                      {t('SIUP Menengah', 'Trading Business License (SIUP – Medium)')}
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-327">
                      {t('Izin Usaha Perdagangan', 'Business Trading Permit')}
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-328">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-329" />
                  <div data-id="element-330">
                    <span className="block font-medium text-gray-900" data-id="element-331">
                      TDP & NPWP
                    </span>
                    <span className="text-sm text-gray-500" data-id="element-332">
                      {t('Terdaftar dan Patuh Pajak', 'Company Registration & Tax ID')}
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* REI Membership Card */}
            <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-2xl border-2 border-blue-200 shadow-premium p-8" data-id="element-333">
              <div className="flex items-center mb-6" data-id="element-334">
                <img src="https://cdn.magicpatterns.com/uploads/xuBA4FLWNXtKdE4fyjLLfC/logoREI.png" alt="REI Logo" className="h-16 w-16 object-contain mr-4" data-id="element-335" />
                <div data-id="element-336">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-337">
                    {t('Anggota Resmi REI', 'Official REI Member')}
                  </h3>
                  <p className="text-sm text-gray-600 font-semibold" data-id="element-338">
                    {t('No. Registrasi: 03.00174', 'Registration No: 03.00174')}
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-339">
                <p className="text-gray-700 leading-relaxed" data-id="element-340">
                  {t('Sebagai anggota Real Estat Indonesia (REI), asosiasi pengusaha real estat terbesar di Indonesia yang didirikan tahun 1972, kami berkomitmen menjalankan praktik bisnis properti yang profesional, etis, dan sesuai standar industri nasional.', 'As a member of Real Estat Indonesia (REI), the largest real estate association in Indonesia established in 1972, we are committed to professional, ethical, and industry-standard property business practices.')}
                </p>

                <div className="bg-white/60 rounded-lg p-4 border border-blue-200" data-id="element-341">
                  <h4 className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-342">
                    <Award className="w-5 h-5 text-blue-600 mr-2" data-id="element-343" />
                    {t('Manfaat Keanggotaan REI', 'REI Membership Benefits')}
                  </h4>
                  <ul className="space-y-2 text-sm text-gray-700" data-id="element-344">
                    <li className="flex items-start" data-id="element-345">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-346" />
                      <span data-id="element-347">
                        {t('Standar etika bisnis properti nasional', 'National property business ethics standards')}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-348">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-349" />
                      <span data-id="element-350">
                        {t('Jaminan kualitas dan profesionalisme', 'Quality and professionalism guarantee')}
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-351">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-352" />
                      <span data-id="element-353">
                        {t('Perlindungan hak konsumen properti', 'Property consumer rights protection')}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Badge */}
          <div className="mt-8 text-center" data-id="element-354">
            <div className="inline-flex items-center space-x-2 px-6 py-3 bg-green-50 border border-green-200 rounded-full" data-id="element-355">
              <Shield className="w-5 h-5 text-green-600" data-id="element-356" />
              <span className="text-sm font-semibold text-green-800" data-id="element-357">
                {t('Legalitas Terjamin & Terdaftar Resmi', 'Guaranteed Legal Compliance & Officially Registered')}
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="py-20 bg-[#C4161C] text-white" data-id="element-358">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-359">
          <div className="inline-block p-3 bg-white/10 rounded-full mb-6" data-id="element-360">
            <Target className="w-8 h-8" data-id="element-361" />
          </div>
          <h2 className="text-3xl font-bold mb-6" data-id="element-362">
            {t('Visi Kami', 'Our Vision')}
          </h2>
          <p className="text-2xl font-medium leading-relaxed" data-id="element-363">
            {t('"Menjadi developer properti terkemuka di Riau yang menghadirkan hunian berkualitas tinggi, berkelanjutan, dan menciptakan komunitas yang harmonis untuk generasi mendatang."', '"To become a leading real estate developer in Riau by delivering high-quality, sustainable properties and fostering harmonious communities for future generations."')}
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 bg-gray-50" data-id="element-364">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
          <div className="text-center mb-16" data-id="element-366">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-367">
              {t('Misi Kami', 'Our Mission')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-368">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-369">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-[#C4161C] mb-6" data-id="element-370">
                <Shield className="w-6 h-6" data-id="element-371" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-372">
                {t('Kualitas Terjamin', 'Guaranteed Quality')}
              </h3>
              <p className="text-gray-600" data-id="element-373">
                {t('Menghadirkan properti dengan standar kualitas internasional dan material terbaik.', 'Deliver properties with high construction standards and premium materials.')}
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-374">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-[#C4161C] mb-6" data-id="element-375">
                <Lightbulb className="w-6 h-6" data-id="element-376" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-377">
                {t('Inovasi Berkelanjutan', 'Sustainable Innovation')}
              </h3>
              <p className="text-gray-600" data-id="element-378">
                {t('Mengembangkan desain hunian yang modern, ramah lingkungan, dan efisien energi.', 'Develop modern, environmentally conscious, and energy-efficient designs.')}
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-379">
              <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-[#C4161C] mb-6" data-id="element-380">
                <Users className="w-6 h-6" data-id="element-381" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-382">
                {t('Kepercayaan Pelanggan', 'Customer Trust')}
              </h3>
              <p className="text-gray-600" data-id="element-383">
                {t('Memberikan layanan transparan, profesional, dan purna jual yang responsif.', 'Provide transparent services and responsive after-sales support.')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-white" data-id="element-384">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-385">
          <div className="text-center mb-16" data-id="element-386">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-387">
              {t('Nilai-Nilai Inti Perusahaan', 'Core Values')}
            </h2>
            <p className="text-gray-600" data-id="element-388">
              {t('Fondasi yang menjadi pegangan kami dalam setiap langkah.', 'The foundation that guides us in every step.')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-389">
            <ValueCard icon={Shield} title={t('Integritas', 'Integrity')} description={t('Komitmen pada kejujuran dan transparansi.', 'Upholding honesty and transparency in every business process.')} data-id="element-390" />
            <ValueCard icon={Award} title={t('Kualitas', 'Quality')} description={t('Standar tertinggi dalam desain dan konstruksi.', 'Maintaining the highest standards in design, construction, and service.')} data-id="element-391" />
            <ValueCard icon={Heart} title={t('Kepercayaan', 'Trust')} description={t('Hubungan jangka panjang dengan konsumen dan mitra.', 'Building long-term relationships with customers and partners.')} data-id="element-392" />
            <ValueCard icon={Leaf} title={t('Keberlanjutan', 'Sustainability')} description={t('Tanggung jawab terhadap lingkungan dan komunitas.', 'Taking responsibility toward the environment and local communities.')} data-id="element-393" />
          </div>
        </div>
      </section>
    </div>;
}